const initialState = {
  // messages: [{
  // 	id: 1,
  // 	name: 'Leonetta Llyod',
  // 	avatar: '',
  // 	text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras id tortor pretium, dictum purus ut, ullamcorper nulla. Curabitur diam metus, suscipit ac mattis sit amet, efficitur non turpis. Fusce ullamcorper lectus et feugiat convallis. Curabitur interdum.',
  // 	type: 'message',
  // 	time: '11:12:48',
  //       seenBy: [{
  //           id: 1,
  //           name: 'Sister'
  //       },
  //       {
  //           id: 2,
  //           name: 'Leona'
  //       },
  //       {
  //           id: 3,
  //           name: 'Ekoterina'
  //       }]
  // },
  // {
  // 	id: 2,
  // 	name: 'Ekaterina',
  // 	avatar: '',
  // 	text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras id tortor pretium, dictum purus ut, ullamcorper nulla. Curabitur diam metus, suscipit ac mattis sit amet, efficitur non turpis. Fusce ullamcorper lectus et feugiat convallis. Curabitur interdum.',
  // 	type: 'message',
  // 	time: '11:12:48',
  //       seenBy: [{
  //           id: 1,
  //           name: 'Leona'
  //       },
  //       {
  //           id: 2,
  //           name: 'Ekoterina'
  //       },
  //       {
  //           id: 3,
  //           name: 'Sister'
  //       }]
  // },{
  // 	id: 3,
  // 	name: 'sister@beam.live',
  // 	avatar: '',
  // 	text: 'has been added to the page by Zsolt',
  // 	type: 'member',
  // 	time: '11:12:48',
  //       seenBy: [{
  //           id: 1,
  //           name: 'Sister'
  //       },
  //       {
  //           id: 2,
  //           name: 'Leona'
  //       },
  //       {
  //           id: 3,
  //           name: 'Ekoterina'
  //       }]
  // },{
  // 	id: 4,
  // 	name: 'Sister',
  // 	avatar: '',
  // 	text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras id tortor pretium, dictum purus ut, ullamcorper nulla. Curabitur diam metus, suscipit ac mattis sit amet, efficitur non turpis. Fusce ullamcorper lectus et feugiat convallis. Curabitur interdum.',
  // 	type: 'message',
  // 	time: '11:35:48',
  //       seenBy: [{
  //           id: 1,
  //           name: 'Sister'
  //       },
  //       {
  //           id: 1,
  //           name: 'Leona'
  //       },
  //       {
  //           id: 1,
  //           name: 'Ekoterina'
  //       }]
  // },{
  // 	id: 3,
  // 	name: 'Leonetta Lloyd',
  // 	avatar: '',
  // 	text: 'has been added to the page by Zsolt',
  // 	type: 'member',
  // 	time: '11:12:48',
  //       seenBy: [{
  //           id: 1,
  //           name: 'Sister'
  //       },
  //       {
  //           id: 1,
  //           name: 'Leona'
  //       },
  //       {
  //           id: 1,
  //           name: 'Ekoterina'
  //       }]
  // }],
  messages: {},
  unProcessedMessages: {},
  messageToSend: undefined,
  focusLatLng: undefined,
};

const getSelectedPageMessages = (
  state: MessageState,
  action: any
): MessageState => {
  const updatedMessages = state.messages;
  const { pageId } = action.payload;
  // const { flag } = action.payload.data;
  const flag = action.payload.refMessage?.referenceType;
  const originalPageMessageId = action.payload?.originalPageMessageId;

  const unProcessedMessages = state.unProcessedMessages;

  console.log("handle text message flag", flag, originalPageMessageId);

  if (updatedMessages[pageId]) {
    if (flag === "update") {
      let index = updatedMessages[pageId].findIndex((x: MessageInfo) => {
        return (
          x.id === originalPageMessageId ||
          x.originalPageMessageId === originalPageMessageId
        );
      });
      updatedMessages[pageId][index] = action.payload;
    } else if (flag === "remove") {
      let index = updatedMessages[pageId].findIndex((x: MessageInfo) => {
        return (
          x.id === originalPageMessageId ||
          x.originalPageMessageId === originalPageMessageId
        );
      });
      updatedMessages[pageId].splice(index, 1);
    } else updatedMessages[pageId].push(action.payload);
  } else {
    updatedMessages[pageId] = [action.payload];
  }

  unProcessedMessages?.[pageId]?.push(action.payload);
  return {
    ...state,
    messages: updatedMessages,
    currentMessage: action.payload.data,
    unProcessedMessages: unProcessedMessages,
  };
};

const deleteMessage = (state: MessageState, action: any): MessageState => {
  let messages = state.messages;
  const { pageId, messageId } = action.payload;

  let index = messages[pageId].findIndex((x: MessageInfo) => {
    return x.id === messageId;
  });
  messages[pageId].splice(index, 1);

  return {
    ...state,
    messages: messages,
  };
};

const updateMessage = (state: MessageState, action: any): MessageState => {
  let messages = state.messages;
  const { pageId, messageId, changes } = action.payload;

  let index = messages[pageId].findIndex((x: MessageInfo) => {
    return x.id === messageId;
  });
  messages[pageId][index].message = changes[0].value;

  return {
    ...state,
    messages: messages,
  };
};

const clearMessage = (state: MessageState, action: any): MessageState => {
  let messages = state.messages;
  const { pageId } = action.payload;
  messages[pageId] = [];
  return {
    ...state,
    messages: messages,
  };
};

const getMessageToSend = (state: MessageState, action: any): MessageState => {
  return {
    ...state,
    messageToSend: action.payload,
  };
};

const setMessageFilter = (state: MessageState, action: any): MessageState => {
  return {
    ...state,
    messageFilter: action.payload,
    searchMessages: { offset: 0, limit: 30, paginate: false, scroll: true },
  };
};

// const setFakeLatLng = (state, action) => {
// 	return {
// 		...state,
// 		focusLatLng: undefined
// 	};
// }

const getUpdatedLatLng = (state: MessageState, action: any): MessageState => {
  // setFakeLatLng(state, action);
  return {
    ...state,
    focusLatLng: { ...action.payload },
  };
};

const getFileToSend = (state: MessageState, action: any): MessageState => {
  return {
    ...state,
    fileToSend: action.payload,
  };
};

const processMessage = (
  updatedMessages: Array<MessageInfo>,
  payload: MessageInfo
): Array<object> => {
  // const flag = payload.data?.flag;
  const flag = payload.refMessage?.referenceType;
  // console.log('flag here', flag, payload)

  // testing fix
  const originalPageMessageId = payload?.originalPageMessageId;
  // const originalPageMessageId = payload?.refMessage?.pageMessageId;

  if (flag === "update") {
    let index = updatedMessages.findIndex((x) => {
      return (
        x.id === originalPageMessageId ||
        x.originalPageMessageId === originalPageMessageId
      );
    });
    updatedMessages[index] = payload;
  } else if (flag === "remove") {
    let index = updatedMessages.findIndex((x) => {
      return (
        x.id === originalPageMessageId ||
        x.originalPageMessageId === originalPageMessageId
      );
    });
    updatedMessages.splice(index, 1);
  } else updatedMessages.push(payload);
  return updatedMessages;
};

const focusMessage = (state: MessageState, action: any): MessageState => {
  return {
    ...state,
    focusMessage: { ...action.payload },
  };
};

const setPageMessages = (state: MessageState, action: any): MessageState => {
  const updatedMessages = state.messages;
  const unProcessedMessages = state.unProcessedMessages;
  const searchMessages = state.searchMessages;
  const { pageId, messages } = action.payload;
  console.log("all messages", messages);
  let allMessages = [];
  if (searchMessages.paginate) {
    allMessages = [...messages, ...(unProcessedMessages[pageId] || [])];
  } else {
    allMessages = messages;
  }
  allMessages = allMessages.filter((x) => {
    return x.messageType !== "log";
  });

  allMessages.sort((a, b) =>
    a.originalCreatedAt > b.originalCreatedAt
      ? 1
      : b.originalCreatedAt > a.originalCreatedAt
      ? -1
      : 0
  );
  let processedMessages = [];
  let messageMap = {};
  allMessages.map((x) => {
    // let id = x.originalPageMessageId || x.id;
    let id = x.originalCreatedAt;
    if (!messageMap?.[id]) messageMap[id] = [];
    messageMap[id].push(x);
  });
  Object.keys(messageMap).map((i) => {
    if (messageMap?.[i]?.length === 1) {
      const x = messageMap?.[i]?.[0];
      if (
        !x.refMessage ||
        (x.refMessage?.referenceType !== "update" &&
          x.refMessage?.referenceType !== "remove")
      ) {
        processedMessages.push(x);
      }
    } else {
      let orinalPageMessageIdMap = {};
      messageMap?.[i].map((x) => {
        let id = x.originalPageMessageId || x.id;
        if (!orinalPageMessageIdMap?.[id]) orinalPageMessageIdMap[id] = [];
        orinalPageMessageIdMap[id].push(x);
      });
      Object.keys(orinalPageMessageIdMap).map((j) => {
        if (orinalPageMessageIdMap?.[j]?.length === 1) {
          processedMessages.push(orinalPageMessageIdMap?.[j]?.[0]);
        } else {
          orinalPageMessageIdMap?.[j].sort((a, b) =>
            a.createdAt > b.createdAt ? 1 : b.createdAt > a.createdAt ? -1 : 0
          );
          const originalMessage = orinalPageMessageIdMap?.[j]?.find((x) => {
            return (
              !x.refMessage ||
              (x.refMessage?.referenceType !== "update" &&
                x.refMessage?.referenceType !== "remove")
            );
          });
          if (
            originalMessage &&
            orinalPageMessageIdMap?.[j]?.[
              orinalPageMessageIdMap?.[j]?.length - 1
            ]?.refMessage?.referenceType === "update"
          ) {
            processedMessages.push(
              orinalPageMessageIdMap?.[j]?.[
                orinalPageMessageIdMap?.[j]?.length - 1
              ]
            );
          }
        }
      });
    }
  });
  // allMessages.map((message)=>{
  //   processedMessages = processMessage(processedMessages, message);
  // })
  updatedMessages[pageId] = processedMessages;
  unProcessedMessages[pageId] = allMessages;
  console.log("messages", processedMessages);
  return {
    ...state,
    messages: updatedMessages,
    unProcessedMessages,
  };
};

const getPageMessages = (state: MessageState, action: any): MessageState => {
  const previousSearchMessages = state.searchMessages || {};
  return {
    ...state,
    searchMessages: { ...previousSearchMessages, ...action.payload },
  };
};

const messageReducer = (
  state: MessageState = initialState,
  action: any
): MessageState => {
  switch (action.type) {
    case "SET_SELECTED_PAGE_MESSAGE":
      return getSelectedPageMessages(state, action);
    case "SEND_MESSAGE":
      return getMessageToSend(state, action);
    case "SET_MESSAGE_FILTER":
      return setMessageFilter(state, action);
    case "DELETE_MESSAGE":
      return deleteMessage(state, action);
    case "UPDATE_MESSAGE":
      return updateMessage(state, action);
    case "CLEAR_MESSAGE":
      return clearMessage(state, action);
    case "CHANGE_MAP_FOCUS":
      return getUpdatedLatLng(state, action);
    case "SET_MESSAGES":
      return setPageMessages(state, action);
    case "FOCUS_MESSAGE":
      return focusMessage(state, action);
    case "ADD_FILE":
      return getFileToSend(state, action);
    case "SEARCH_MESSAGES":
      return getPageMessages(state, action);
    default:
      return state;
  }
};

export default messageReducer;
